import React, {useState} from 'react';
import {useLocation} from 'react-router-dom';
import {Button, IconButton, Snackbar} from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import {SITE_PUBLIC} from '../config';
import {esteCordova} from '../router';
// Iconitele compacte de pe cardurile de lucrari (Distribuie + inima din LikeButton): mici (16px), gri stins si
// semi-transparente in repaus; activ / hover caramiziu-gri — accentul temei amestecat cu gri, in ambele moduri.
export const caramiziuGri = (theme) => `color-mix(in srgb, ${theme.palette.primary.main} 55%, ${theme.palette.text.secondary})`;
export const sxIconCompact = (activ = false) => ({
    p: .5,
    opacity: activ ? 1 : .6,
    color: (theme) => (activ ? caramiziuGri(theme) : theme.palette.text.secondary),
    '& svg': {fontSize: 16},
    '&:hover': {color: caramiziuGri, opacity: 1},
});

// Pasul 37: „Distribuie” pe lucrare / membru / expoziție. Linkul e mereu adresa publică
// (SITE_PUBLIC + calea din router, fără query) — la fel pe web și în APK, ca destinatarul să vadă
// previzualizarea (og:*) a paginii. APK → meniul nativ Android (cordova-plugin-x-socialsharing);
// web cu navigator.share → meniul nativ al browserului; altfel → linkul copiat în clipboard.
export const adresaPublica = (pathname) => `${SITE_PUBLIC}${pathname.startsWith('/') ? pathname : `/${pathname}`}`;

// Mesaj scurt inaintea linkului, uniform pe lucrare / membru / expozitie.
// Nu dublam punctele daca apelantul a trimis deja un text terminat cu elipsa.
export const textDistribuire = (text, titlu) => {
    const mesaj = String(text || titlu || '').trim().replace(/(?:\.{3}|…)$/, '');
    return mesaj ? `${mesaj}...` : '';
};

const anulat = (e) => e?.name === 'AbortError' || /cancel/i.test(String(e?.message || e || ''));

// 54.5: `cale` — pe carduri se distribuie lucrarea / expozitia / membrul cardului, nu pagina curenta;
// `compact` — doar iconita (cardurile de lucrari din grila).
export default function DistribuieButton({titlu, text, cale, compact = false}) {
    const {pathname} = useLocation();
    const [mesaj, setMesaj] = useState('');
    const url = adresaPublica(cale || pathname);

    const distribuie = async () => {
        const mesajDistribuire = textDistribuire(text, titlu);
        const sharing = window.plugins?.socialsharing;
        if (esteCordova() && sharing) {
            // Închiderea meniului fără alegere nu e o eroare de afișat.
            sharing.shareWithOptions({message: mesajDistribuire, subject: titlu, url, chooserTitle: 'Distribuie'},
                () => {}, (e) => { if (!anulat(e)) setMesaj('Distribuirea nu a reușit.'); });
            return;
        }
        if (navigator.share) {
            try {
                await navigator.share({title: titlu, text: mesajDistribuire, url});
            } catch (e) {
                if (!anulat(e)) setMesaj('Distribuirea nu a reușit.');
            }
            return;
        }
        try {
            await navigator.clipboard.writeText(url);
            setMesaj('Link copiat');
        } catch {
            setMesaj(url);
        }
    };

    return <>
        {compact
            ? <IconButton size="small" onClick={distribuie} aria-label="Distribuie" title="Distribuie" sx={sxIconCompact()}><ShareIcon fontSize="small" /></IconButton>
            : <Button size="small" variant="outlined" startIcon={<ShareIcon />} onClick={distribuie} sx={{flexShrink: 0}}>Distribuie</Button>}
        <Snackbar open={!!mesaj} autoHideDuration={3000} onClose={() => setMesaj('')} message={mesaj}
                  anchorOrigin={{vertical: 'bottom', horizontal: 'center'}} />
    </>;
}

// Titlul paginii cu butonul alături; pe telefon butonul trece dedesubt dacă nu încape.
// 54.5: `like` — butonul „Apreciază”, grupat înaintea lui „Distribuie”.
export const TitluCuDistribuie = ({children, titlu, text, like}) => (
    <div style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap', marginBottom: 8}}>
        <div style={{flex: '1 1 14rem', minWidth: 0, overflowWrap: 'anywhere'}}>{children}</div>
        {like ? <div style={{display: 'flex', gap: 8, flexWrap: 'wrap', flexShrink: 0}}>
            {like}
            <DistribuieButton titlu={titlu} text={text} />
        </div> : <DistribuieButton titlu={titlu} text={text} />}
    </div>
);
